export const expression = /[^[\d]]*/g;

export default (value: string): string => value.replace(expression, '');
